import { render, staticRenderFns } from "./MdRenderFallback.vue?vue&type=template&id=2559fecc&scoped=true"
import script from "./MdRenderFallback.vue?vue&type=script&lang=js"
export * from "./MdRenderFallback.vue?vue&type=script&lang=js"
import style0 from "./MdRenderFallback.vue?vue&type=style&index=0&id=2559fecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559fecc",
  null
  
)

export default component.exports